module.exports = __webpack_public_path__ + "02b463ee727e0525f7e86bf44f4a3973.png";